<template>
  <div class="common-avatar">
    <div v-if="iconPath" class="common-avatar-imgWrapper">
      <img v-bind:src="iconPath" v-bind:alt="fullName" />
    </div>
    <span v-else v-bind:title="fullName">
      {{ showName(fullName) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'common-avatar',
  props: {
    iconPath: {
      required: true,
      type: String,
      default: ''
    },
    fullName: {
      required: true,
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    // 若无图标，展示文字
    showName: function(name) {
      // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
      if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
        return name.length > 2 ? name.slice(-2) : name
      } else if (/^[A-Za-z]+$/g.test(name)) {
        // 纯英文名只展示两个字母
        return name.slice(0, 2)
      } else {
        // 其他
        return name.slice(0, 2)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.common {
  &-avatar {
    display: inline-block;
    flex-shrink: 0;
    width: 66px;
    height: 66px;
    line-height: 66px;
    vertical-align: middle;
    background: #4196ff;
    border-radius: 50%;
    font-size: 26px;
    text-align: center;
    color: #fff;
    &-imgWrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 50%;
      & > img {
        width: 100%;
        min-height: 100%;
      }
    }
    & > span {
      display: inline-block;
      letter-spacing: 1px;
    }
  }
}
</style>
